/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Missing_Machine_Id_ErrorInputs */

const en_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a machine id.`)
};

const fr_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un identifiant de machine.`)
};

const de_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine Maschinen-ID ein.`)
};

const it_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un ID macchina.`)
};

const ru_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите идентификатор машины.`)
};

const es_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese un ID de máquina.`)
};

const zh_cn2_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入机器ID。`)
};

const ja_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マシンIDを入力してください。`)
};

const hi_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया मशीन आईडी दर्ज करें।`)
};

const pt_pt2_offline_activation_missing_machine_id_error = /** @type {(inputs: Offline_Activation_Missing_Machine_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um ID de máquina.`)
};

/**
* | output |
* | --- |
* | "Please enter a machine id." |
*
* @param {Offline_Activation_Missing_Machine_Id_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_missing_machine_id_error = /** @type {((inputs?: Offline_Activation_Missing_Machine_Id_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Missing_Machine_Id_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_missing_machine_id_error(inputs)
	if (locale === "de") return de_offline_activation_missing_machine_id_error(inputs)
	if (locale === "it") return it_offline_activation_missing_machine_id_error(inputs)
	if (locale === "ru") return ru_offline_activation_missing_machine_id_error(inputs)
	if (locale === "es") return es_offline_activation_missing_machine_id_error(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_missing_machine_id_error(inputs)
	if (locale === "ja") return ja_offline_activation_missing_machine_id_error(inputs)
	if (locale === "hi") return hi_offline_activation_missing_machine_id_error(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_missing_machine_id_error(inputs)
	return en_offline_activation_missing_machine_id_error(inputs)
});